import { Link } from "react-router-dom";

function CtaBanner() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20close%20up%20of%20hands%20placing%20a%20folded%20note%20into%20a%20plain%20wooden%20box%20on%20warm%20paper%20surface%2C%20sepia%20and%20deep%20crimson%20tones%2C%20soft%20dramatic%20side%20light%2C%20cinematic%20editorial%20photography%2C%20no%20text%20no%20faces&width=1800&height=800&seq=cta-baoliao-01&orientation=landscape"
          alt="向爆料平台匿名提交线索的示意画面"
          title="匿名提交爆料线索"
          className="h-full w-full object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/75 to-foreground-950/60" />
      </div>

      <div className="relative z-10 w-full px-4 py-16 md:px-8 md:py-24">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 text-xs font-label tracking-widest text-background-100 backdrop-blur">
            <i className="ri-lock-2-line text-accent-400" />
            匿名入口 24 小时开放
          </span>
          <h2 className="mt-6 font-heading text-2xl font-bold leading-tight text-background-50 md:text-4xl">
            手里有材料？先放出来，剩下交给流程
          </h2>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-200 md:text-base">
            不需要注册账号，也不强制留下联系方式。把时间、地点和经过说清楚，材料我们会妥善归类。
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/submit"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3.5 text-sm font-label font-medium text-background-950 transition-colors hover:bg-accent-600"
            >
              <i className="ri-send-plane-fill" />
              进入匿名投稿
            </Link>
            <Link
              to="/faq"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/35 px-6 py-3.5 text-sm font-label font-medium text-background-50 transition-colors hover:bg-background-50/10"
            >
              先看看注意事项
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CtaBanner;